import axiosClient from "..";
import { getErrorMessageObj } from "../../../container/SportsBookNode/utils/common/functions";

export default class BetslipService {
  static placeBet(data) {
    return axiosClient
      .post("/sb/betPlace", data)
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        return getErrorMessageObj(error);
      });
  }
}
